export default "<ng-content select=\"axis-expand-collapse-body\"></ng-content>\r\n<ng-content select=\"axis-expand-collapse-right\"></ng-content>";